import { MergeRequest } from '../types/MergeRequest';
import { SimpleScore } from '@internal/ui-common';
import { scoreRules } from './scoreRules';

const calculateScore = (mrs: MergeRequest[]): SimpleScore => {
  const counts = { red: 0, orange: 0, green: 0 };
  mrs.forEach(mr => {
    if (scoreRules.red.rule(mr.days_count, mr.pipeline_count)) {
      counts.red++;
    } else if (scoreRules.orange.rule(mr.days_count, mr.pipeline_count)) {
      counts.orange++;
    } else {
      counts.green++;
    }
  });
  return counts;
};

export const getRenovateScore = (
  mrs: MergeRequest[] | undefined,
): SimpleScore => {
  if (mrs?.length) {
    const counts = calculateScore(mrs);
    return counts;
  }
  return { red: 0, orange: 0, green: 0 };
};
